/* import __COLOCATED_TEMPLATE__ from './notifications-list-empty-state.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import TEMPLATE from "./notifications-list-empty-state.hbs";
import { setComponentTemplate } from "@ember/component";
export default setComponentTemplate(TEMPLATE, templateOnlyComponent());